<template>
  <article class="blog_item">
    <div class="blog_item_img">
      <img class="card-img rounded-0" :src="post.thumbnail" :alt="post.title" />
      <router-link :to="`/post/${post.id}`" class="blog_item_date">
        <h3>{{ new Date(post.createdDate).getDate() }}</h3>
        <p>{{ months[new Date(post.createdDate).getMonth()] }}</p>
      </router-link>
    </div>
    <div class="blog_details">
      <router-link class="d-inline-block" :to="`/post/${post.id}`">
        <h2 class="blog-head" style="color: #2d2d2d;">
          {{ post.title }}
        </h2>
      </router-link>
      <p
        v-if="post.content.length"
        v-html="`${markdownConverter(post.content).substring(0, 200)}...`"
      />
    </div>
  </article>
</template>

<script>
import { getImgUrl } from "@/mixins/getImgUrl";
import { months } from "@/utils/months";
import marked from "marked";

export default {
  name: "Post",
  mixins: [getImgUrl],
  props: {
    post: {
      type: Object,
      required: true,
      default: () => ({
        months: [],
      }),
    },
  },
  created() {
    this.months = months;
  },

  methods: {
    markdownConverter(content) {
      return marked(content);
    },
  },
};
</script>

<style></style>
